import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Martín', 'Lucas', 'Federico', 'Sofía', 'Camila', 'Agustín', 'Tomás', 'Valentina', 'Mateo', 'Joaquín', 'Florencia', 'Bruno', 'Nicolás', 'Julieta', 'Emiliano'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán', 'Bariloche', 'Neuquén', 'San Juan', 'Bahía Blanca', 'Santa Fe', 'El Chaltén', 'Ushuaia'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then repeat every 12-18 seconds
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 6000) + 12000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-133">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-24 md:bottom-8 left-4 z-50 bg-card border border-gray-800 rounded-lg shadow-2xl p-4 flex items-center gap-4 max-w-[300px]" data-id="element-134">
          <div className="bg-green-500/20 p-2 rounded-full flex-shrink-0" data-id="element-135">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-136" />
          </div>
          <div data-id="element-137">
            <p className="text-sm text-white font-medium leading-tight" data-id="element-138">
              <span className="font-bold" data-id="element-139">{data.name}</span> de {data.city}{' '}
              acaba de comprar Escalada Pro System
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-140">
              hace {data.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}